module.exports = __webpack_public_path__ + "static/media/evisect.cd0fd45f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/paratrioza/curativa/evisect.png
// module id = 2001
// module chunks = 3